import { SVGProps } from "react";

const Modification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.2227 2.16675H7.77932C5.47182 2.16675 3.59766 4.05175 3.59766 6.34841V21.6126C3.59766 23.5626 4.99516 24.3859 6.70682 23.4434L11.9935 20.5076C12.5568 20.1934 13.4668 20.1934 14.0193 20.5076L19.306 23.4434C21.0177 24.3967 22.4152 23.5734 22.4152 21.6126V6.34841C22.4043 4.05175 20.5302 2.16675 18.2227 2.16675Z"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.2227 2.16675H7.77932C5.47182 2.16675 3.59766 4.05175 3.59766 6.34841V21.6126C3.59766 23.5626 4.99516 24.3859 6.70682 23.4434L11.9935 20.5076C12.5568 20.1934 13.4668 20.1934 14.0193 20.5076L19.306 23.4434C21.0177 24.3967 22.4152 23.5734 22.4152 21.6126V6.34841C22.4043 4.05175 20.5302 2.16675 18.2227 2.16675Z"
      stroke="currentColor"
      strokeWidth={1.3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Modification;
